import { useCallback } from 'react'
import { Outlet } from 'react-router-dom'
import { useLocation, Link } from 'react-router-dom'
import { ROUTE_PATHS } from '@constants'

import './KitchenSink.css'

const links = [
    ['HOME', ROUTE_PATHS.KITCHEN_SINK],
    ['DOCUMENT EXPLORER', ROUTE_PATHS.KITCHEN_SINK_DOCUMENT_EXPLORER],
    ['RENDER PDF', ROUTE_PATHS.KITCHEN_SINK_RENDER_PDF],
    ['LABEL STUDIO', ROUTE_PATHS.KITCHEN_SINK_LABEL_STUDIO],
    ['TYPOGRAPHY', ROUTE_PATHS.KITCHEN_SINK_TYPOGRAPHY],
    ['REALTIME', ROUTE_PATHS.KITCHEN_SINK_REALTIME],
    ['WORKER DEBUG', ROUTE_PATHS.KITCHEN_SINK_WORKER_DEBUG],
    ['CLIENT PDF SPLIT', ROUTE_PATHS.KITCHEN_SINK_CLIENT_PDF_SPLIT],
]

const KitchenSink = () => {
    
    const location = useLocation()
    
    const classFor = useCallback(url => (
        'link' + (location.pathname === `${ROUTE_PATHS.KITCHEN_SINK}/${url}` ? ' active' : '')
    ), [location])
    
    return (
        
        <div id="KitchenSink">
            
            <nav className="flex items-center content-center gap-4">
                {links.map(([label, url]) => (
                    <Link
                        key={url}
                        className={classFor(url)}
                        to={url}>
                        {label}
                    </Link>
                ))}
            </nav>
            
            <main>
                <Outlet />
            </main>
        
        </div>
        
    )
    
}

export default KitchenSink
